import { render, staticRenderFns } from "./aiLectureFreePage.vue?vue&type=template&id=731e2c24&scoped=true&"
import script from "./aiLectureFreePage.vue?vue&type=script&lang=js&"
export * from "./aiLectureFreePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e2c24",
  null
  
)

export default component.exports